
;(function(global, $){
	var InstamapsDadesExternes = function(options){
		return new InstamapsDadesExternes.init(options);
	};

	var _options = {
		proxyUrl: ""
	};

	InstamapsDadesExternes.prototype = {
		initUi: function(){
			var self = this;
			self._div = self.container;
			if (self.loadTemplateParam==undefined) self.loadTemplate();
			return self;
		},

		loadTemplate: function(){
			var self = this;
			$.get("/static/geocatweb/templates/dadesExternesBotoTemplate.html",function(data){
				self._div.html(data);
				self._uiloaded = true;
				
				$(".div_dadesExternes_menu").hide();
				$(".input_dadesExternes_url").focus(function() {
					//self.clear();
				});

				$( ".input_dadesExternes_url" ).keypress(function( event ) {
					  if ( event.which == 13 ) {
					     event.preventDefault();
					     self.send($(this).val());
					  }

				});

				$(".bt_dadesExternes_url").on('click', function(e) {
					var input = $(e.target).closest(self._div).find('.input_dadesExternes_url');
				    var url = $.trim(input.val());

				    self.send(url);

				});
				

			});
			return self;
		},
		send:function(url){
			var self = this;
			if (url === "") {
				
				
				alert(window.lang.translate("Has d'introduïr una URL del servidor"));
			} else if (!InstamapsUtils.Validator.isValidURL(url)) {
				//alert(window.lang.translate("La URL introduïda no sembla correcte"));
				self.clear();
				self.show();
				
				$('.div_dadesExternes_menu').html(
					'<div id="txt_URLfile_error" class="alert alert-danger">'+
						'<span class="glyphicon glyphicon-warning-sign"> </span> '+
								window.lang.translate("Introdueix una URL vàlida")+
					'</div>'
				);

			} else {
				self.clear();
				self.addFormDadesExternes(url);
			}

			return self;
		},
		clear: function(){

			var self = this;
			$('.div_dadesExternes_menu').hide();
			$('.div_dadesExternes_menu').html('');

			return self;
		},

		show: function(){
			var self = this;
			$(".div_dadesExternes_menu").show();
		
			return self;
		},

		activarEventAfegirCapa:function(type,urlFile){
			var self = this;
			var nom_capa = window.lang.translate("Capa de fitxer");
			if(type!=undefined && type!="-1") nom_capa+=type;
			$(".input-url-file-name_de").val(nom_capa);

			$(".bt_URLfitxer_go_de").on('click', function(e) {
				e.stopImmediatePropagation();
				$(".div_url_file_message_de").empty();
				$(".div_url_file_message_de").hide();

				var type = $(".select-url-file-format_de").val();
				var epsg = $(".select-url-file-epsg_de").val();
				var opcio = jQuery('.nav-pills-urlfile .active').attr('id');
				var coordX = $("#input-coord-x").val();
				var coordY = $("#input-coord-y").val();
				var coordWKT =  $("#input-coord-wkt").val();

				if(type!=undefined && type.indexOf("-1")!= -1 || epsg!=undefined && epsg.indexOf("-1")!= -1 && opcio!=undefined && opcio!="codis" && opcio!="adreca"){
					if(type.indexOf("-1")!= -1) $(".select-url-file-format_de").addClass("class_error");
					if(epsg.indexOf("-1")!= -1) $(".select-url-file-epsg_de").addClass("class_error");

				}else if( type!=undefined && (type==".xls" || type==".xlsx" || type==".csv" || type==".txt")
							&&  opcio == "coordenades" && (!InstamapsUtils.Validator.isValidValue(coordX) || !InstamapsUtils.Validator.isValidValue(coordY) ) &&  !InstamapsUtils.Validator.isValidValue(coordWKT)  ){

					if(!InstamapsUtils.Validator.isValidValue(coordX)) $("#input-coord-x").addClass("class_error");
					if(!InstamapsUtils.Validator.isValidValue(coordY)) $("#input-coord-y").addClass("class_error");
					if(!InstamapsUtils.Validator.isValidValue(coordWKT)) $("#input-coord-wkt").addClass("class_error");

				}else if( type!=undefined && (type==".xls" || type==".xlsx" || type==".csv" || type==".txt")
							&&  opcio == "codis" && (!InstamapsUtils.Validator.isValidValue($(".input-camp-codi-urlfile_de").val())) ){

					$(".input-camp-codi-urlfile_de").addClass("class_error");

				}else{
					if(!busy){
						busy = true;
						var urlFileInput = $('#txt_URLfile').val();
						if (urlFileInput!==urlFile) {
							urlFile = urlFileInput;
						}
						var dinamic;
						var limitest = $('#input-num-reg-est').val();
						var limitdin = $('#input-num-reg-din').val();
						if ($('#dinamic_chck').bootstrapSwitch('state')){
							dinamic=false;
							if (limitest!==undefined && limitest!==""){
								urlFile = urlFile.substring(0,urlFile.indexOf("LIMIT"));
								urlFile = urlFile+" LIMIT "+limitest;
							}
			        	}
			        	else{
							dinamic=true;
							if (limitdin!==undefined && limitdin!==""){
								urlFile = urlFile.substring(0,urlFile.indexOf("LIMIT"));
								urlFile = urlFile+" LIMIT "+limitdin;
							}
						}
						
						var artVia=jQuery("#cmd_upload_url_artVia").val();
						var tipVia=jQuery("#cmd_upload_url_tipVia").val();
						var nomVia=jQuery("#cmd_upload_url_nomVia").val();
						var portal=jQuery("#cmd_upload_url_portal").val();
						var municipi=jQuery("#cmd_upload_url_url_municipi").val();
						var carretera=jQuery("#cmd_upload_url_carretera").val();
						var pk=jQuery("#cmd_upload_url_pk").val();
						var caixaUnica=jQuery("#cmd_upload_url_caixaUnica").val();
						var topo=jQuery("#cmd_upload_url_topo").val();

						var cc=$('input:radio[name="opt_url_adreca_field2"]:checked').val();
						var camps = "";
						var campUnic = "";
						if (cc==="parts"){
							camps= artVia+","+tipVia+","+nomVia+","+portal+","+municipi+","+carretera+","+pk+","+topo;
						}
						else if (cc==="unica"){
							campUnic = caixaUnica;
						}
						var separadorCamps = $('input:radio[name="separadorUrlCamps"]:checked').val();
						

						createURLfileLayer(urlFile, type, epsg, dinamic,$(".input-url-file-name_de").val(),
							$("#input-coord-x").val(),$("#input-coord-y").val(),
							jQuery('.nav-pills-urlfile .active').attr('id'),//per coordenades o codis o adreces
							jQuery('.cmd_codiType_Capa_de').val(), jQuery('.cmd_codiType_de').val(), $(".input-camp-codi-urlfile_de").val(),'','',$("#input-coord-wkt").val(),
							campUnic,camps,separadorCamps);

					}else{
						self.clear();
						$('#dialog_info_upload_txt').html(window.lang.translate("S'està processant un arxiu. Si us plau, espereu que aquest acabi."));
						$('#dialog_info_upload').modal('show');

					}
				}
			});

			return self;

		},

		addFormDadesExternes:function(urlFile){

			var self = this;
			self.show();
		
			if(urlFile.indexOf(paramUrl.presidentJSON)!= -1){
				getServeiJSONP(urlFile);
			}else if(urlFile.indexOf("socrata")!= -1 && urlFile.indexOf("method=export&format=GeoJSON")!= -1){

				$.get("/static/geocatweb/templates/dadesExternesSocrataTemplate.html",function(data){
					$(".div_dadesExternes_menu").html(data);
					$(".div_url_file_message_de").hide();
					self.activarEventAfegirCapa("-1",urlFile); //TODO verificar
				});

			}else{

				$.get("/static/geocatweb/templates/dadesExternesTemplate.html",function(data){

					try{
					$(".div_dadesExternes_menu").html(data);
					$('.make-switch').bootstrapSwitch();
					
					$('#label-estatic').attr("style","display:none;");
					$('input[name="dinamic-checkbox"]').on('switchChange.bootstrapSwitch', function(event, state) {
	            		if(state.value == true) {
	            			$('#label-dinamic').attr("style","display:none;");
	            			$('#label-estatic').attr("style","display:inline;");
	            		}
	            		else {
	            			$('#label-dinamic').attr("style","display:inline;");
	            			$('#label-estatic').attr("style","display:none;");
	            		}
					});
					$(".div_url_file_message_de").hide();
					$(".input-excel-url-file_de").hide();
					var type = "-1";
					if(urlFile.indexOf(t_file_kml)!=-1) { type = t_file_kml;}
					else if(urlFile.indexOf(t_file_gpx)!=-1) { type = t_file_gpx;}
					else if(urlFile.indexOf(t_file_shp)!=-1) {type = t_file_shp;}
					else if(urlFile.indexOf(t_file_dxf)!=-1) {type = t_file_dxf;}
					else if(urlFile.indexOf(t_file_xlsx)!=-1) { type = t_file_xlsx;}
					else if(urlFile.indexOf(t_file_xls)!=-1) { type = t_file_xls;}
					else if(urlFile.indexOf(t_file_topojson)!=-1) { type = t_file_geojson;}
					else if(urlFile.indexOf(t_file_geojson)!=-1) { type = t_file_geojson;}
					else if(urlFile.indexOf(t_file_json)!=-1) { type = t_file_geojson;}
					else if(urlFile.indexOf(t_file_csv)!=-1) { type = t_file_csv;}
					else if(urlFile.indexOf(t_file_txt)!=-1) { type = t_file_txt;}
					else if(urlFile.indexOf(t_file_dgn)!=-1) { type = t_file_dgn;}
					else if(urlFile.indexOf(t_file_gml)!=-1) { type = t_file_gml;}
					else if(urlFile.indexOf(t_file_json)!=-1) {type = t_file_json;}


					$('.select-url-file-format_de option[value="'+type+'"]').prop("selected", "selected");

					if (type==".kml" ||type==".geojson" ||type==".gpx" || type==".gml"){
						$('.select-url-file-epsg_de option[value="EPSG:4326"]').prop("selected", "selected");
						$(".select-url-file-epsg_de").attr('disabled',true);
					}else if(type==".xls" || type==".xlsx" || type==".csv" || type==".txt"){
						$(".input-excel-url-file_de").show();
						$('.input-excel-url-file_de .nav-pills-urlfile li#codis').removeClass("disabled");
						$('.input-excel-url-file_de .nav-pills-urlfile li a[href="#opt_urlfile_codi"]').attr("data-toggle","tab");
					}else if(type==".json"){
						jQuery(".input-excel-url-file_de").show();
						$('.input-excel-url-file_de .nav-pills-urlfile li#codis').removeClass("disabled");
						$('.input-excel-url-file_de .nav-pills-urlfile li a[href="#opt_urlfile_codi"]').attr("data-toggle","tab");
					}else{
						$('.select-url-file-epsg_de option[value="-1"]').prop("selected", "selected");
						$(".select-url-file-epsg_de").attr('disabled',false);
					}

					self.activarEventAfegirCapa(type,urlFile);


					jQuery('input:radio[name="opt_url_csv_field2"]').on('click', function() {
						var ori=this.id;
						
						if(ori.indexOf('coords')!=-1){
							jQuery('#ul_urlfile_coords').show();
							jQuery('#ul_urlfile_geom').hide();				
						}else if(ori.indexOf('geom')!=-1){
							jQuery('#ul_urlfile_coords').hide();
							jQuery('#ul_urlfile_geom').show();	
						}else{		
							jQuery('#ul_urlfile_coords').toggle();
							jQuery('#ul_urlfile_geom').toggle();
						}		
					});	

					$('.cmd_codiType_Capa_de').on('change',function(e) {
						var html = "";
						if ($(this).val() == "municipis") {
							html = "<option value='ine'>INE (5 digits)</option><option value='idescat'>IDESCAT (6 digits)</option><option value='municat'>MUNICAT (10 digits)</option><option value='cadastre'>CADASTRE (5 digits)</option>";
						} else if ($(this).val() == "comarques") {
							html = "<option value='ine'>NUM_COMARCA (2 digits)</option><option value='municat'>MUNICAT (10 digits)</option>";
						} else if ($(this).val() == "provincies"){
							html = "<option value='codiprov'>CODIPROV (2 digits)</option><option value='codiens'>MUNICAT (10 digits)</option>";
						} else if ($(this).val() == "abs2016" || $(this).val() == "abs2018"){
							html = "<option value='codiabs'>CODIABS (3 digits)</option>";
						} else if ($(this).val() == "abss2017" || $(this).val() == "abss2019"){
							html = "<option value='codi'>CODI (3 digits)</option>";
						} else if (jQuery(this).val() == "abss2022"){
							html = "<option value='codi'>CODI (3 digits)</option>";		
						} else if ($(this).val() == "ambitsfunc"){
							html = "<option value='codi àmbit'>CODI ÀMBIT (1 digit)</option>";
						} else if ($(this).val() == "seccensals"){
							html = "<option value='mundissec'>MUNDISSEC (11 digits)</option>";
						} else if ($(this).val() == "seccensals2020_ine"){
							html = "<option value='cusec'>CUSEC (10 digits)</option>";
						}  else if ($(this).val() == "partitsjudicials"){
							html = "<option value='partits ju'>PARTITS JU (2 digits)</option>";
						} else if ($(this).val() == "sabp"){
							html = "<option value='codirp'>CODI RP (1 digit)</option><option value='codiabp'>CODI ABP (2 digits)</option>";
						} else if ($(this).val() == "regsanitaries" ){
							html = "<option value='codi rs'>CODI RS(1 digit)</option>";
						} else if ($(this).val() == "regsanitaries2018" ){
							html = "<option value='codirs'>CODI RS(2 digits)</option>";
						}  else if ($(this).val() == "regpolicials"){
							html = "<option value='codirp'>CODI RP(1 digit)</option>";
						}  else if ($(this).val() == "paisos"){
							html = "<option value='cod_un'>CODI ONU (3 digits)</option><option value='cod2alpha'>CODI ALPHA (2 lletres)</option><option value='cod3alpha'>CODI ALPHA (3 lletres)</option><option value='cctld'>CODI TLD (domini .xx)</option>";
						} else if ($(this).val() == "aga2018"){
							html = "<option value='codiaga'>CODI AGA (2 digits)</option>";				
						} else if ($(this).val() == "ss2018"){
							html = "<option value='codiss'>CODI SS (4 digits)</option>";				
						} else if ($(this).val() == "distnot"){
							html = "<option value='district_1'>CODI DISTRICTE (10 digits)</option>";					
						} else if (jQuery(this).val() == "refcadastre"){
							html = "<option value='refcadastral'>REFERENCIA CADASTRAL</option>";	
						}
			
						$('.cmd_codiType_de').html(html);
					});

					$('.nav-pills-urlfile #codis').on('click', function(){
						$(".select-url-file-epsg_de").attr('disabled',true);
					});

					$('.nav-pills-urlfile #coordenades').on('click', function(){
						$(".select-url-file-epsg_de").attr('disabled',false);
					});

					$('.nav-pills-urlfile #adreca').on('click', function(){
						$(".select-url-file-epsg_de").attr('disabled',true);
					});

					$("#input-coord-x").focus(function() {
						$(this).removeClass("class_error");
					});

					$("#input-coord-y").focus(function() {
						$(this).removeClass("class_error");
					});

					$(".input-camp-codi-urlfile_de").focus(function() {
						$(this).removeClass("class_error");
					});

					$('input:radio[name="opt_url_adreca_field2"]').on('click', function() {
						var ori=this.id;
						console.debug(ori);
						if(ori.indexOf('unica')!=-1){
							jQuery('#ul_url_adreca_unica').show();
							jQuery('#ul_url_adreca_parts').hide();				
						}else if(ori.indexOf('parts')!=-1){
							jQuery('#ul_url_adreca_unica').hide();
							jQuery('#ul_url_adreca_parts').show();	
						}else{		
							jQuery('#ul_url_adreca_unica').toggle();
							jQuery('#ul_url_adreca_parts').toggle();
						}		
					});

					$(".select-url-file-epsg_de").change(function(){
						$(this).removeClass("class_error");
						$(".div_url_file_message_de").empty();
						$(".div_url_file_message_de").hide();
					});

					$('.select-url-file-format_de').change(function() {
						$(this).removeClass("class_error");
						$(".div_url_file_message_de").empty();
						$(".div_url_file_message_de").hide();
						$(".input-excel-url-file_de").hide();

						var ext = $(this).val();
						if ((ext==".kml")||(ext==".gpx") ||(ext==".gml")){
							$('.select-url-file-epsg_de option[value="EPSG:4326"]').prop("selected", "selected");
							$(".select-url-file-epsg_de").attr('disabled',true);
//							$(".input-excel-url-file").hide();
						}else if((ext==".xls")||(ext==".xlsx") || (ext==".csv") || (ext==".txt") ){
							$(".input-excel-url-file_de").show();
							$('.input-excel-url-file_de .nav-pills-urlfile li#codis').show();
							$('.input-excel-url-file_de .nav-pills-urlfile li#adreca').show();
							$('.input-excel-url-file_de .nav-pills-urlfile li#codis').removeClass("disabled");
							$('.input-excel-url-file_de .nav-pills-urlfile li a[href="#opt_urlfile_codi"]').attr("data-toggle","tab");
						}else if(ext==".json"){
							$(".input-excel-url-file_de").show();
							$('a[href^="#opt_urlfile_coord').click();
							//$('#opt_url_csv_coords').attr('checked', true);
							$('.input-excel-url-file_de .nav-pills-urlfile li#codis').hide();
							$('.input-excel-url-file_de .nav-pills-urlfile li#adreca').hide();
						}else{
							$(".select-url-file-epsg_de").attr('disabled',false);
//							$(".input-excel-url-file_de").hide();
						}

						
					});// fi templates
					var isDo = $('#bt_URLfitxer').data('isDO');
					if (isDo){
						$('.div_dadesExternes_menu #input-url-file-name')[0].value=$("#name-resource")[0].value;
						$('.div_dadesExternes_menu #select-url-file-format').attr('disabled','disabled');
						$('.div_dadesExternes_menu #separador').hide();
						$('.div_dadesExternes_menu #select-url-file-epsg').attr('disabled','disabled');
					}
					}catch(Err){
						//$.publish('analyticsEvent',{event:['error', 'Error addFormDadesExternes',JSON.stringify(Err)]});
						console.debug(Err);
					}
					if ($('#es-estatic').val()=="true"){
						$('#dinamic_chck').click()
					}					

				});// fi templates



			}//fi else resta


			return self;

	}



	};	//fi prototype

	InstamapsDadesExternes.init = function(options){
		var self = this;
		self = $.extend(self, _options, options);
		self.initUi();
	};

	InstamapsDadesExternes.init.prototype = InstamapsDadesExternes.prototype;

	global.InstamapsDadesExternes = InstamapsDadesExternes;

}(window, jQuery));
